// extracted by mini-css-extract-plugin
export default {"bar":"CatalogFilters_bar__bGkXk"};